import React from "react";

import {
    Autocomplete,
    Checkbox,
    FormControl,
    ListItemText,
    TextField,
} from "@mui/material";

import ClipLoader from "react-spinners/ClipLoader";

import "./selectPixel.css";

function SelectPixelComponent({
    data,
    selectedType,
    selectedValues,
    setSelectedValues,
    isLoading = false,
    disabled = false,
}) {
    const handleSelectPixels = (e) => {
        setSelectedValues(e);
    };

    if (isLoading) {
        return (
            <div className="sweet-loading my-2">
                <ClipLoader color="#729abf" size={32} />
            </div>
        );
    }

    return (
        <div>
            <>
                <FormControl fullWidth variant="outlined" className="my-2">
                    <Autocomplete
                        multiple
                        disableCloseOnSelect
                        disabled={disabled}
                        options={data?.children ?? []}
                        value={selectedValues}
                        onChange={(e, newValue) =>
                            handleSelectPixels(newValue)
                        }
                        getOptionLabel={(option) => option?.label ?? ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.value === value?.value
                        }
                        renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.value}>
                                <Checkbox checked={selected} />
                                <ListItemText primary={option.label} />
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={
                                    selectedType === "ttoffline"
                                        ? "Offline Event Set Id"
                                        : "Select Pixel Id"
                                }
                            />
                        )}
                    />
                </FormControl>
            </>
        </div>
    );
}

export default SelectPixelComponent;
